const PATH = '/provider/:f([a-z0-9-]{0,}?)?-:providerId([a-z0-9]{6,})';

export default {
  path: PATH,

  load: (context: any, params: any) => import(/* webpackChunkName: 'provider' */ './index'),
};
